export default __webpack_public_path__ + "eccdc3ebdac96050a9d720b31c860973.svg";